<style lang="scss" scoped>
header {
    position: relative;
    height: 65px;
    z-index: 2;
    box-shadow: inset 0 -1px 0 #e4e4e4;

    @media screen and (max-width: 767.98px) {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
    }

    .home-link {
        color: var(--accent);
        font-size: 1.5rem;
        transition: color 0.15s;

        &:hover {
            color: var(--dark);
        }
    }

    h1,
    a {
        color: var(--dark);
        font-size: 1rem;
        line-height: 1;
        text-shadow: none;
        font-weight: 500;
    }

    a {
        transition: color 0.15s;
        &:hover {
            text-decoration: none;
            color: var(--accent);
        }

        &.save,
        &.share {
            span {
                ::v-deep svg {
                    display: inline-block;
                    margin-left: 8px;
                    width: 14px;
                    height: 14px;
                    transition: color 0.15s;
                    transform: translateY(-2px);

                    path {
                        transition: fill 0.15s;
                    }
                }
            }

            &:hover {
                span {
                    ::v-deep svg {
                        path {
                            fill: var(--accent);
                        }
                    }
                }
            }
        }

        &.request-button {
            color: #fff !important;
            transition: background-color 0.15s;

            &:after {
                display: inline-block;
                margin-left: 16px;
                content: url("/svg/arrow-right-smaller-white.svg");
                width: 12px;
                height: 11px;
                transition: transform 0.15s;
            }

            &:hover {
                &:after {
                    transform: translateX(4px);
                }
            }
        }
    }

    .share-mobile {
        display: flex;
        height: 64px;
        width: 64px;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        ::v-deep .icon {
            path {
                fill: #fff;
            }
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<template>
    <header v-show="translations != null && translations.header != null" class="d-flex justify-content-between pl-24 align-items-center">
        <div class="d-flex align-items-center">
            <a :href="route('nl.home')" class="font-weight-light link home-link mr-32 d-none d-md-inline-block">
                <strong>InspireYourTribe</strong>.be
            </a>

            <h1 class="d-md-none d-xl-block">{{ translations.header.title }}</h1>
        </div>

        <transition name="fade">
            <div class="d-flex align-items-center h-100" v-if="showButtons">
                <a @click.prevent="showShareModal" class="mr-56 d-none d-md-inline-block share">{{ translations.header.share }}<span v-html="svg('share', 'icon')"></span></a>
                <a @click.prevent="requestOffer" class="h-100 request-button px-16 py-24 bg-accent d-none d-md-flex">{{ translations.header.request_offer }}</a>
            </div>
        </transition>

        <div class="share-mobile d-md-none bg-accent h-100" @click.prevent="showShareModal" v-if="showButtons">
            <span v-html="svg('share', 'icon')"></span>
        </div>
    </header>
</template>

<script>
import core from "./day-configurator-core";
import ShareModal from "./modals/day-configurator-share-modal";
import { bus } from '@/app';

export default {
    mixins: [core],

    methods: {
        showShareModal() {
            this.$modal.show(ShareModal, { localSchedule: this.schedule }, { adaptive: true, pivotY: this.$root.isMobile ? 1 : 0.5 , classes: 'py-30', width: '720', height: 'auto', scrollable: true })
        },

        requestOffer() {
            bus.$emit('changeStep', 'request-offer');
        }
    },

    computed: {
        showButtons() {
            return this.schedule.id != null
        }
    }
}
</script>